import type { NetworkType } from '@mls-wallet/shared-types';
import type { DecodedParameterNode } from './decoders';
import { GeneralizedContractCard } from './GeneralizedContractCard';
import type { AddressBookExactEntry } from '@/types/address-book';

interface ContractTxDataProps {
  functionName: string;
  contractAddress: string;
  parameters: DecodedParameterNode[];
  nativeTokenValue?: { value: string; decimals: number };
  networkId: NetworkType;
  addressBookEntryByAddress?: Map<string, AddressBookExactEntry>;
}

/**
 * Display-only contract interaction data.
 */
export function ContractTxData({
  functionName,
  contractAddress,
  parameters,
  nativeTokenValue,
  networkId,
  addressBookEntryByAddress,
}: ContractTxDataProps): React.ReactElement {
  return (
    <div className="w-full">
      <GeneralizedContractCard
        functionName={functionName}
        contractAddress={contractAddress}
        {...(nativeTokenValue ? { nativeTokenValue } : {})}
        networkId={networkId}
        parameters={parameters}
        {...(addressBookEntryByAddress ? { addressBookEntryByAddress } : {})}
      />
    </div>
  );
}
